import React, { useRef } from "react";
import dayjs from "dayjs";
import ButtonWithLoading from "../../../../../../components/ButtonWithLoading";
import { UploadFiles } from "../../../../../../components/Upload";
import { Box, Grid, IconButton, Input, InputAdornment, TextField, Typography } from "@material-ui/core";
import { getTranslation } from "../../../../../../heplers/translationHelper";
import { useState } from "react";
import { Post } from "../../../../../../actions";
import { Post_InsertNotes_URL } from "../../../../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { DatePicker } from "../../../../../../components/DatePicker";
import { AttachFile, Clear, CloudUpload } from "@material-ui/icons";
import { generateFileBase64, generateFileJson } from "../../../../../../heplers/file";

const AddNoteDialog = ({
	setAddNoteDialog,
	noteStatus,
	tenantId,
	recoveryProcedureId,
	setRefresh,
}) => {
	const [fileAddress, setFileAddress] = useState();
	const [noteLoading, setNoteLoading] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	const PostNotes = (payload) => {
		setNoteLoading(true);
		Post(
			payload,
			Post_InsertNotes_URL,
			null,
			(resp) => {
				enqueueSnackbar("Notes added successfully", { variant: "success" });
				setNoteLoading(false);
				setAddNoteDialog(false);
				setRefresh(true);
			},
			(err) => {
				enqueueSnackbar(
					err?.data
						? err?.data
						: getTranslation(
								"Something went wrong. Please try again.",
								"Something went wrong. Please try again.",
								"Something went wrong. Please try again."
						  ),
					{
						variant: "error",
					}
				);
				setNoteLoading(false);
			}
		);
	};

	const initialValues = {
		tenantId: tenantId ? tenantId : "",
		recoveryProcedureId: recoveryProcedureId ? recoveryProcedureId : null,
		comments: "",
		document: "",
		type: noteStatus == "recoveryprocedure" ? 0 : noteStatus == "all" ? 2 : 1,
		date: dayjs().format("YYYY-MM-DD"),
	};

	const basicValidationSchema = Yup.object().shape({});

	const defaultValue = initialValues;

	const fileRef = useRef(null);
	  const handleClick = () => {
    fileRef.current.click();
  };

  const handleClear=()=>{
if (fileRef.current) {
      fileRef.current.value = '';
    }
  }

	return (
		<>
			<Formik
				enableReinitialize
				initialValues={defaultValue}
				validationSchema={basicValidationSchema}
				onSubmit={(values, actions) => {
					actions.setSubmitting(true);
					PostNotes(values, actions);
					actions.setSubmitting(false);
				}}
			>
				{({
					values,
					setFieldValue,
					errors,
					touched,
					handleChange,
					handleSubmit,
					isSubmitting,
					getFieldProps,
				}) => (
					<Form>
						<Grid container style={{ marginTop: "10px" }}>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<DatePicker
									fullWidth
									variant="outlined"
									id="date"
									disabled={true}
									label={getTranslation("Date", "Date", "Date")}
									value={values.date}
									onChange={(date) => {
										setFieldValue("date", date.toString());
									}}
									error={touched.date && Boolean(errors.date)}
								/>
							</Grid>

							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={{ marginTop: "20px" }}
							>
								<TextField
									fullWidth
									id="comments"
									label={getTranslation("Comment", "Comment", "Comment")}
									size="small"
									variant="outlined"
									multiline
									rows={5}
									name="comments"
									{...getFieldProps("comments")}
									error={touched.comments && Boolean(errors.comments)}
									helperText={touched.comments && errors.comments}
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={{ marginTop: "20px" }}
							>
								
								{/* <input
									type="file"
									hidden
									// ref={fileInputRef}
									onChange={(e) => {
										const file = e.target.files[0];
										if (file) {
											setFieldValue("documentName", file.name);
										setFieldValue("document", file);
										}
									}}
								/> */}

								<div >
									{/* Hidden File Input */}
									<input
										type="file"
										ref={fileRef}
										hidden
										onChange={(e) => {
											const file = e.target.files[0];
											generateFileBase64(file).then(base64String=>{
												setFieldValue("document", base64String)}).catch(error=>{
												console.error("File upload error",error)

												});
											
											// // Convert file to base64
											// const reader = new FileReader();
											// reader.onload = (event) => {
											// 	const base64String = event.target.result;
											// 	setFieldValue("document", base64String);
											// };
											// reader.onerror = (error) => {
											// 	console.error('Error reading file:', error);
											// 	// Optionally, you can also save the file object as fallback
											// 	setFieldValue("document", file);
											// };
											// reader.readAsDataURL(file); // This reads file as base64 data URL
										}}
									/>

									{/* Visible Text Input */}
									<Input
										title="Upload"
										value={values.documentName}
										readOnly
										disabled={false}
										placeholder={getTranslation(
											"Upload Attachment",
											"Upload Attachment",
											"Upload Attachment"
										)}
							
										fullWidth
										endAdornment={
											<InputAdornment position="end">
												{values.documentName ? (
													<IconButton
														onClick={() => {
															handleClear();
															setFieldValue("documentName", "");
															setFieldValue("document", null);
														}}
														size="small"
														style={{ marginRight: 4 }}
													>
														<Clear fontSize="small" />
													</IconButton>
												) : null}
												<IconButton
													onClick={handleClick}
													size="small"
												>
													{values.documentName ? null : <CloudUpload />}
												</IconButton>
											</InputAdornment>
										}
										inputProps={{
											style: {
												cursor: 'default',
												color: values.documentName ? 'inherit' : 'rgba(0, 0, 0, 0.54)',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
												paddingRight: 70, // Space for icons
											}
										}}
										style={{
											border: `1px solid rgba(0, 0, 0, 0.23)`,
											borderRadius: 4,
											padding: '8px 14px',
										}}
										onFocus={(e) => {
											e.target.style.borderColor = '#3f51b5';
											e.target.style.borderWidth = '2px';
										}}
										onBlur={(e) => {
											e.target.style.borderColor = 'rgba(0, 0, 0, 0.23)';
											e.target.style.borderWidth = '1px';
										}}
									/>
								</div>
								
								<Typography variant="h5">
									{getTranslation(
										"Upload Attachment",
										"Upload Attachment",
										"Upload Attachment"
									)}
								</Typography>
							</Grid>

							<Box
								pr={1}
								pb={1}
								width="100%"
								display="flex"
								alignItems="center"
								justifyContent="center"
							>
								<ButtonWithLoading
									style={{
										marginTop: "10px",
										backgroundColor: "rgb(229,60,22)",
										color: "white",
									}}
									title={getTranslation("Add", "Add", "Add")}
									size="small"
									variant="contained"
									color="primary"
									loading={noteLoading}
									onClick={handleSubmit}
								/>
							</Box>
						</Grid>
					</Form>
				)}
			</Formik>
		</>
	);
};

export default AddNoteDialog;
